import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";


export const initialShareInformation = {
    subject: "",
    icon: "",
    description: "",
    classes: [],
    teacher: false,
    parent: false,
    file: ""
}

export const initialRemindAboutEvent = {
    title: "",
    description: "",
    icon: "",
    classes: [],
    teacher: false,
    parent: false
}

export const initialCreatePollForm = {
    question: "",
    description: "",
    options: [],
    last_voting_date: moment(new Date()).format("YYYY-MM-DD"),
    end_time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    classes: [],
    teacher: false,
    parent: false
}

export const initialFeesReminderForm = {
    student_list: [],
    description: "",
    icon: "",
    title: ""
}

const boardcast = createSlice({
    name: "boardcast",
    initialState: {
        popup: {
            remindAboutEvent: false,
            createPoll: false,
            information: false,
            feesReminder: false,
            boardcastPopup: false
        },
        form: {
            remindAboutEventForm: initialRemindAboutEvent,
            createPollForm: initialCreatePollForm,
            shareAnInformationForm: initialShareInformation,
            feesReminderForm: initialFeesReminderForm
        },
        other: {
            boardcastMessage: null
        }
    },
    reducers: {

        // open and close popup action
        openRemindAboutEvent: (state) => {
            state.popup.remindAboutEvent = true
        },
        closeRemindAboutEvent: (state) => {
            state.popup.remindAboutEvent = false
        },
        openCreatePoll: (state) => {
            state.popup.createPoll = true
        },
        closeCreatePoll: (state) => {
            state.popup.createPoll = false
        },
        openInformation: (state) => {
            state.popup.information = true
        },
        closeInformation: (state) => {
            state.popup.information = false
        },
        openFeesReminder: (state) => {
            state.popup.feesReminder = true
        },
        closeFeesReminder: (state) => {
            state.popup.feesReminder = false
        },
        openBoardcastPopup: (state, action) => {
            state.popup.boardcastPopup = true
            state.other.boardcastMessage=action.payload
        },
        closeBoardcastPopup: (state) => {
            state.popup.boardcastPopup = false
            state.other.boardcastMessage=null
        },

        // form action
        addRemindAboutEventForm: (state, action) => {
            state.form.remindAboutEventForm = action.payload
        },
        addCreatePollForm: (state, action) => {
            state.form.createPollForm = action.payload
        },
        addFeesReminderForm: (state, action) => {
            state.form.feesReminderForm = action.payload
        },
        addShareAnInformationForm: (state, action) => {
            state.form.shareAnInformationForm = action.payload
        },
    }
})

export const { openRemindAboutEvent, openCreatePoll, closeRemindAboutEvent,
    closeCreatePoll, openInformation, closeInformation, closeBoardcastPopup,
    closeFeesReminder, openFeesReminder, addCreatePollForm, openBoardcastPopup,
    addFeesReminderForm, addRemindAboutEventForm, addShareAnInformationForm } = boardcast.actions

export default boardcast.reducer

// popup state
export const getRemindAboutEvent = state => state.boardcast.popup.remindAboutEvent
export const getCreatePoll = state => state.boardcast.popup.createPoll
export const getInformation = state => state.boardcast.popup.information
export const getFeesReminder = state => state.boardcast.popup.feesReminder
export const getBoardcastPopup = state => state.boardcast.popup.boardcastPopup

// form state
export const getRemindAboutEventForm = state => state.boardcast.form.remindAboutEventForm
export const getCreatePollForm = state => state.boardcast.form.createPollForm
export const getFeesReminderForm = state => state.boardcast.form.feesReminderForm
export const getShareAnInformationForm = state => state.boardcast.form.shareAnInformationForm

// other state
export const getBoardcastMessage = state =>state.boardcast.other.boardcastMessage

